export default function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
}



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-selection/src/selection/datum.js